/**
 * Rascunho local dos treinos sugeridos (onboarding) — sobrevive ao fechar o modal / página.
 * v2: prompt compacto + composição default treino_principal (invalida rascunhos antigos).
 */

export const ONBOARDING_DRAFT_VERSION = 2;
export const ONBOARDING_DRAFT_ENGINE_TAG = 'compact-v2';

const legacyKey = (userId) => `iron_onboarding_pack_${String(userId)}`;
const keyV2 = (userId) => `iron_onboarding_pack_v2_${String(userId)}`;

const LEGACY_SEGMENT_RE = /\[(Aquecimento|Alongamento|Desaquecimento)\]/i;

function hasLegacySegmentTags(suggestions) {
  for (const w of suggestions || []) {
    for (const it of w.items || []) {
      const text = `${it?.name || ''} ${it?.notes || ''}`;
      if (LEGACY_SEGMENT_RE.test(text)) return true;
    }
  }
  return false;
}

function isDraftValid(parsed) {
  if (!parsed || typeof parsed !== 'object') return false;
  if ((parsed.draftVersion || 0) < ONBOARDING_DRAFT_VERSION) return false;
  const comp = parsed.workoutComposition;
  const legacyComp =
    Array.isArray(comp) && comp.includes('aquecimento') && comp.includes('desaquecimento');
  if (legacyComp && hasLegacySegmentTags(parsed.suggestions)) return false;
  return true;
}

/** Remove chave v1 (pré compact prompt). Chamar no hydrate. */
export function purgeLegacyOnboardingDrafts(userId) {
  if (!userId || typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(legacyKey(userId));
  } catch {
    /* ok */
  }
}

export function readOnboardingDraft(userId) {
  if (!userId || typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(keyV2(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!isDraftValid(parsed)) {
      localStorage.removeItem(keyV2(userId));
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writeOnboardingDraft(userId, draft) {
  if (!userId || typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(
      keyV2(userId),
      JSON.stringify({
        ...draft,
        draftVersion: ONBOARDING_DRAFT_VERSION,
        engineTag: ONBOARDING_DRAFT_ENGINE_TAG,
        savedAt: new Date().toISOString()
      })
    );
  } catch {
    /* quota / private mode */
  }
}

export function clearOnboardingDraft(userId) {
  if (!userId || typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(keyV2(userId));
    localStorage.removeItem(legacyKey(userId));
  } catch {
    /* ok */
  }
}
